import { get, post } from '@/utils/ajax'

export function getExamCheckInfo(examId) {
  return get(`/home/exams/check/${examId}`)
}

export function startExam({ examId, examineeId }) {
  return post(`/home/edu/examinees/start/${examId}/${examineeId}`)
}

/**
 * 添加考生身份证信息
 * @param {Object} data
 * @param {string} data.examId
 * @param {string} data.identity_card_front
 * @param {string} data.identity_card_back
 */
export function addExamIdCard({
  examId,
  identity_card_front,
  identity_card_back
}) {
  return post(`/home/abnormal/${examId}/face-info/add`, {
    identity_card_front,
    identity_card_back
  })
}

/**
 * 检查考生身份证信息
 * @param {string} examId
 */
export function checkExamIdCard(examId) {
  return post(`/home/abnormal/${examId}/face-info`)
}
